import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { wordCountHelper } from "../../../seoAnalyzer/contentHelper";

export default function ContentCard({ analysis, content, general }) {
  const { t } = useTranslation();
  const length = useMemo(() => {
    return content?.url.full
      ? wordCountHelper(
          analysis?.content.nb_words,
          general?.content_length.medium
        ).score
      : 0;
  }, [analysis]);
  return analysis !== undefined && content !== undefined ? (
    <>
      <div className="py-3">
        <div className="break-words">
          {/* Aricle Length */}
          <div className="text-xs text-black  ">
            <span>
              {" "}
              {t("Article-length", "Article length")}?{" "}
              <span
                className={`${
                  length && analysis?.content.nb_words > 0 === 100
                    ? "text-green-500"
                    : length == 70 && analysis?.content.nb_words > 0
                    ? "text-yellow-500"
                    : analysis?.content.nb_words > 0
                    ? "text-red-600"
                    : "text-gray_local-400"
                }`}
              >
                {`${
                  analysis?.content.nb_words > 0
                    ? `${analysis?.content.nb_words} ${t("word", "word")}${
                        analysis?.content.nb_words > 0 ? t("s", "s") : ""
                      }`
                    : t("no_content", "No content")
                }`}
              </span>
            </span>
          </div>

          {/* Content Architecture */}
          <div className="text-xs   text-black">
            <span>
              {" "}
              {t("Content-architecture", "Content architecture")}?{" "}
              <span
                className={`${
                  analysis?.content.content_architecture == 2 &&
                  analysis?.content.nb_words > 0
                    ? "text-green-500"
                    : analysis?.content.content_architecture == 1 &&
                      analysis?.content.nb_words > 0
                    ? "text-yellow-500"
                    : analysis?.content.nb_words > 0
                    ? "text-red-600"
                    : "text-gray_local-400"
                }`}
              >
                {`${
                  analysis?.content.content_architecture == 2 &&
                  analysis?.content.nb_words > 0
                    ? t("Good", "Good")
                    : analysis?.content.content_architecture == 1 &&
                      analysis?.content.nb_words > 0
                    ? t("Middle", "Middle")
                    : analysis?.content.nb_words > 0
                    ? t("Bad", "Bad")
                    : t("no_content", "No content")
                }`}
              </span>
            </span>
          </div>

          {/*Target request in first 150 words*/}
          <div className="text-xs   text-black">
            <span>
              {" "}
              {t(
                "Target-request-in-first-150-words",
                "Target request in first 150 words"
              )}
              ?{" "}
              <span
                className={`${
                  analysis?.content.seo_request_in_first_150 &&
                  analysis?.content.nb_words > 0 == 2
                    ? "text-green-500"
                    : analysis?.content.seo_request_in_first_150 == 1 &&
                      analysis?.content.nb_words > 0
                    ? "text-yellow-500"
                    : analysis?.content.nb_words > 0
                    ? "text-red-600"
                    : "text-gray_local-400"
                }`}
              >
                {`${
                  analysis?.content.seo_request_in_first_150 &&
                  analysis?.content.nb_words > 0 == 2
                    ? t("Yes", "Yes")
                    : analysis?.content.seo_request_in_first_150 == 1 &&
                      analysis?.content.nb_words > 0
                    ? t("Partially", "Partially")
                    : analysis?.content.nb_words > 0
                    ? t("No", "No")
                    : t("no_content", "No content")
                } `}
              </span>
            </span>
          </div>

          {/* Paragraph Density */}
          <div className="text-xs   text-black">
            <span>
              {t(
                "Paragraphs-with-good-density",
                "Paragraphs with good density"
              )}
              ?
              <span
                className={`${
                  100 - analysis?.content.good_density_paragraphs < 25 &&
                  analysis?.content.nb_words > 0
                    ? "text-green-500"
                    : 100 - analysis?.content.good_density_paragraphs > 50 &&
                      analysis?.content.nb_words > 0
                    ? "text-red-600"
                    : 100 - analysis?.content.good_density_paragraphs >= 25 &&
                      analysis?.content.nb_words > 0
                    ? "text-yellow-500"
                    : analysis?.content.nb_words > 0
                    ? "text-red-600"
                    : "text-gray_local-400"
                }`}
              >
                {" "}
                {`${
                  analysis?.content.nb_words > 0
                    ? `${analysis?.content.good_density_paragraphs}%`
                    : t("no_content", "No content")
                }`}
              </span>
            </span>
          </div>
        </div>
      </div>
    </>
  ) : null;
}
